import { Inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ApiService } from "./api.service";
import { BASE_URL } from "./injection-tokens";
import { SendGridDynamicTemplate } from "../models/sendgrid-dynamic-template";

export abstract class SendGridUtilServiceBase {
    abstract getDynamicTemplates(): Observable<SendGridDynamicTemplate[]>;
}

@Injectable({ providedIn: 'root' })
export class SendGridUtilService extends SendGridUtilServiceBase {
    constructor(
        private _api: ApiService,
        @Inject(BASE_URL) private _baseUrl: string,
    ) {
        super();
    }

    override getDynamicTemplates(): Observable<SendGridDynamicTemplate[]> {
        return this._api.makeAPIGetCall<{ templates: any[] }>(this._baseUrl, "/sendgridutil/templates", {}, {})
            .pipe(map(response => (response.templates ?? []).map((json: any) => SendGridDynamicTemplate.fromJSON(json))));
    }
}